module.exports = __webpack_public_path__ + "assets/img/exchange.1f526d55.png";